import { render } from "./banner-video.vue?vue&type=template&id=591be33e"
import script from "./banner-video.vue?vue&type=script&lang=js"
export * from "./banner-video.vue?vue&type=script&lang=js"

import "./banner-video.vue?vue&type=style&index=0&id=591be33e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/banner-video.vue'],['render',render],['__file',"banner-video.vue"]])

export default __exports__